<template>
    <div class="modal fade" tabindex="-1" role="dialog" :id="id">
        <div class="modal-dialog" role="document" :class="{ 'modal-lg': size === 'large', 'modal-sm': size === 'small', 'modal-xl': size === 'extra-large' }">
            <div class="modal-content">
                <div class="modal-header">
                    <app-sub-title :text="title" />
                    <button v-if="closeButton" type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <slot name="body"></slot>
                </div>
                <div class="modal-footer">
                    <button v-if="closeButton" type="button" class="btn btn-secondary" data-dismiss="modal"><i class="fa fa-close"></i> Cerrar</button>
                    <slot name="buttons"></slot>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import SubTitle from '../../Layout/SubTitle.vue';
    export default {
        components: {
            appSubTitle: SubTitle
        },
        props: {
            id: {
                type: String,
                required: true
            },
            onClose: {
                type: Function
            },
            onShowUp: {
                type: Function
            },
            closeButton: {
                type: Boolean,
                default: true
            },
            title: {
                type: String,
                default: ''
            },
            options: {
                type: Object
            },
            size: {
                type: String,
                default: '',
                validator: function (value) {
                    // The value must match one of these strings
                    return ['', 'large', 'small', 'extra-large'].indexOf(value) !== -1
                }
            }
        },
        mounted(){
            $(`#${this.id}`).on('hide.bs.modal', (e) => {
                typeof this.onClose === 'function' && this.onClose();
            });

            $(`#${this.id}`).on('shown.bs.modal', (e) => {
                typeof this.onShowUp === 'function' && this.onShowUp();
            });

            
            let windowOptions = Object.assign({
                show: true
            }, this.options);

            this.$bus.$on(`${this.id}.open`, () => {
                // $(`#${this.id}`).modal('show');
                $(`#${this.id}`).modal(windowOptions);
            });
            this.$bus.$on(`${this.id}.close`, () => {
                $(`#${this.id}`).modal('hide');
                
            });
        },
        beforeDestroy(){
            this.$bus.$off(`${this.id}.open`);
            this.$bus.$off(`${this.id}.close`);
        }
    }
</script>